<div class="container">

  <div class="loader" *ngIf="loading"></div>

  <div *ngIf="mode == 'EDIT' && !loading" class="animated fadeIn">
    <nav class="navbar navbar-light bg-light fixed-top mt-fixed-top">
      <div class="container">
        <span class="navbar-text">
          Ausencia
        </span>
        <div class="pull-right">
          <button class="btn btn-secondary me-1" *ngIf="model.id" data-bs-toggle="modal" data-bs-target="#loadFile" title="Cargar comprobantes">
            <span class="fa fa-upload fa-lg "></span>
          </button>
          <button class="btn btn-secondary me-1" (click)="cancelEvent()">
            Cerrar
          </button>
          <button class="btn btn-primary" (click)="saveEvent()">
            Guardar
          </button>
        </div>
      </div>
    </nav>

    <div class="row" *ngIf="(absencesByDate != undefined && absencesByDate.length > 0) || (workdayLogs != undefined && workdayLogs.length > 0)">
      <ul class="list-group p-3">

        <li class="list-group-item list-group-item-warning" *ngFor="let absense of  absencesByDate">
          <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1" *ngIf="absense.type == 'MEDICAL_DISABILITY'">Ausencia por Incapacidad</h5>
            <h5 class="mb-1" *ngIf="absense.type == 'PAID_VACATION'">Ausencia por Vacaciones pagas</h5>
            <h5 class="mb-1" *ngIf="absense.type == 'UNPAID_VACATION'">Ausencia por Vacaciones no pagas</h5>
            <h5 class="mb-1" *ngIf="absense.type == 'PAID_LEAVING'">Permiso con goce de salario</h5>
            <h5 class="mb-1" *ngIf="absense.type == 'UNPAID_LEAVING'">Permiso sin goce de salario</h5>
            <h5 class="mb-1" *ngIf="absense.type == 'OTHER'">Ausencia</h5>
            <small class="text-body-secondary">{{absense.hours}} hora(s)</small>
          </div>
          <p class="mb-1">Ya se registró una ausencia para la misma fecha y empleado seleccionado.</p>
          <small class="text-body-secondary">Detalles: {{absense.details ? absense.details : '[Sin Detalles]'}}</small>
        </li>

        <li class="list-group-item list-group-item-warning" *ngFor="let workDayLog of  workdayLogs">
          <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1">Horas registradas</h5>
            <small class="text-body-secondary">{{workDayLog.workedHours}} hora(s)</small>
          </div>
          <p class="mb-1">Ya se registraron horas trabajadas para la misma fecha y empleado seleccionado.</p>
          <small class="text-body-secondary">Detalles: {{workDayLog.date}}</small>
        </li>

      </ul>
    </div>

    <div class="row g-3 mb-3">
      <div class="col-md-6">
        <div class="form-group">
          <label for="employee">Empleado</label>
          <select class="form-select" id="employee" name="employee" [(ngModel)]="model.employee" (ngModelChange)="fetchAbsencesEvent()" [disabled]="model.id !== undefined">
            <option [ngValue]="undefined">Seleccione...</option>
            <option *ngFor="let employee of employees" [ngValue]="employee.id" [class.text-danger]="employee.archived">{{employee.name}} {{employee.lastName}} {{employee.archived? ' (Archivado)' : ''}}</option>
          </select>
          <div *ngIf="formErrors.get('absence.employee')" class="badge bg-danger animated fadeIn">
            {{ formErrors.get('absence.employee') }}
          </div>
          <div *ngIf="formErrors.get('employee')" class="badge bg-danger animated fadeIn">
            {{ formErrors.get('employee') }}
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="type">Tipo</label>
          <select class="form-select" id="type" name="type" [(ngModel)]="model.type" [disabled]="model.id !== undefined">
            <option value="PAID_VACATION">Vacaciones Pagadas</option>
            <option value="UNPAID_VACATION">Vacaciones No Pagadas</option>
            <option value="MEDICAL_DISABILITY">Enfermedad</option>
            <option value="PAID_LEAVING">Permiso con goce de salario</option>
            <option value="UNPAID_LEAVING">Permiso sin goce de salario</option>
            <option value="OTHER">Otro</option>
          </select>
          <div *ngIf="formErrors.get('absence.type')" class="badge bg-danger animated fadeIn">
            {{ formErrors.get('absence.type') }}
          </div>
          <div *ngIf="formErrors.get('type')" class="badge bg-danger animated fadeIn">
            {{ formErrors.get('type') }}
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="date">Fecha</label>
          <mt-date-picker [(date)]="model.date" name="date" id="date" label="Fecha" (dateChange)="fetchAbsencesEvent()" [disabled]="model.id !== undefined"/>
          <div *ngIf="formErrors.get('absence.date')" class="badge bg-danger animated fadeIn">
            {{ formErrors.get('absence.date') }}
          </div>
          <div *ngIf="formErrors.get('date')" class="badge bg-danger animated fadeIn">
            {{ formErrors.get('date') }}
          </div>
        </div>
      </div>
      <div class="col-md-6"  *ngIf="model?.id == undefined">
        <div class="form-group">
          <label for="hours">Días </label>
          <span class="text-muted small"> (A partir de la fecha, no contar feriados o dias no laborables)</span>
          <input type="number" class="form-control" id="days" name="days" [(ngModel)]="model.days">
          <div *ngIf="formErrors.get('absence.days')" class="badge bg-danger animated fadeIn">
            {{ formErrors.get('absence.days') }}
          </div>
          <div *ngIf="formErrors.get('days')" class="badge bg-danger animated fadeIn">
            {{ formErrors.get('days') }}
          </div>
        </div>
      </div>
      <div class="col-md-6"  *ngIf="model?.type !== 'PAID_VACATION' && model?.type !== 'MEDICAL_DISABILITY'">
        <div class="form-group">
          <label for="hours">Horas</label>
          <mt-time-picker [(time)]="model.hours" name="hours" label="Horas" [meridian]="false"/>
          <div *ngIf="formErrors.get('absence.hours')" class="badge bg-danger animated fadeIn">
            {{ formErrors.get('absence.hours') }}
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="details">Detalles</label>
          <input type="text" class="form-control" id="details" name="details" [(ngModel)]="model.details">
          <div *ngIf="formErrors.get('absence.details')" class="badge bg-danger animated fadeIn">
            {{ formErrors.get('absence.details') }}
          </div>
        </div>
      </div>
    </div>

    <div class="mb-3 card">
      <h5 class="card-header">
        Comprobantes
      </h5>
      <div class="card-body">
        <table *ngIf="attachments != undefined && attachments.length > 0" class="table table-hover">
          <thead>
          <tr>
            <td>Archivo</td>
            <td></td>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let attachment of attachments; let i = index">
            <td class="mt-content-col align-middle">
              <span [title]="attachment.name">{{attachment.name}}</span>
            </td>
            <td class="mt-actions-col">
              <button class="btn btn-secondary pull-right  me-1" (click)="downloadAttachment(attachment.id, attachment.name)" title="Descargar">
                <span class="fa fa-download fa-lg"></span>
              </button>
              <button class="btn btn-warning pull-right"(click)="selectedAttachment = attachment" data-bs-toggle="modal" data-bs-target="#removeAttachmentConfirmation" title="Remover">
                <span class="fa fa-trash fa-lg"></span>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
        <div *ngIf="attachments == undefined || attachments.length == 0" class="p-3">
          No hay comprobantes adjuntos
        </div>
      </div>
    </div>

  </div>

  <div *ngIf="mode == 'LIST' && !loading" class="animated fadeIn">

    <nav class="navbar navbar-light bg-light fixed-top mt-fixed-top">
      <div class="container-fluid">
        <form class="d-flex">
          <mt-date-picker [(date)]="from" label="Desde" class="input-group me-2" (dateChange)="onFromChange()"/>
          <mt-date-picker [(date)]="to" label="Hasta" class="input-group me-2" (dateChange)="onToChange()"/>

          <select class="form-select me-2" id="employeeFilter" name="employeeFilter" [(ngModel)]="employeeId" (ngModelChange)="refreshEvent()" title="Empleado">
            <option [ngValue]="-1">Todos</option>
            <option *ngFor="let employee of employees" [ngValue]="employee.id" [class.text-danger]="employee.archived">{{ employee.name }}  {{employee.lastName}} {{employee.archived? ' (Archivado)' : ''}}</option>
          </select>

          <select class="form-select me-2" id="absenceTypeFilter" name="absenceTypeFilter" [(ngModel)]="absenceType" (ngModelChange)="refreshEvent()" title="Tipo de ausencia">
            <option [ngValue]="'ALL'">Todos</option>
            <option *ngFor="let type of absenceTypes" [ngValue]="type">{{ getAbsenceTypeLabel(type) }}</option>
          </select>

        </form>
        <div class="pull-right">
          <button class="btn btn-link" (click)="refreshEvent()" title="Refrescar">
            <span class="fa fa-sync fa-lg"></span>
          </button>
          <button type="button" class="btn btn-secondary me-1" data-bs-toggle="modal" data-bs-target="#vacationsReportDialog" (click)="openVacationsReportDialog()" title="Boleta de Vacaciones">
            <span class="fa fa-file-export fa-lg "></span>
          </button>
          <button type="button" class="btn btn-secondary me-1" (click)="exportPaidLeaves()" title="Reporte de permisos con goce de salario">
            <span class="fa fa-download fa-lg "></span>
          </button>
          <button class="btn btn-primary" (click)="createEvent()" title="Nuevo">
            <span class="fa fa-plus fa-lg"></span>
          </button>
        </div>
      </div>
    </nav>

    <mt-pagination (loadPage)="getPageEvent($event)" [page]="page"></mt-pagination>

    <table *ngIf="page.metadata.pages > 0" class="table table-hover">
      <thead>
        <tr>
          <th>
            Empleado
          </th>
          <th scope="col">
            Fecha
          </th>
          <th scope="col">
            Horas
          </th>
          <th scope="col">
            Detalles
          </th>
          <th>

          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let absence of page.content">
          <td (click)="editEvent(absence)" class="mt-content-col" [class.text-danger]="absence.employeeArchived">
            {{absence.employeeName}} {{absence.employeeArchived? ' (Archivado)' : ''}}
          </td>
          <td (click)="editEvent(absence)" class="mt-content-col ">
            {{absence.date}}
          </td>
          <td (click)="editEvent(absence)" class="mt-content-col ">
            {{absence.hours}}
          </td>
          <td (click)="editEvent(absence)" class="mt-content-col">
            <span class="mt-large-text">{{absence.details}}</span>
          </td>
          <td class="mt-actions-col">
            <button class="btn btn-link btn-lg pull-right" data-bs-toggle="modal" data-bs-target="#absenceConfirmation"
                    (click)="selectEvent(absence)" title="Borrar">
              <span class="fa fa-trash-alt fa-lg"></span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="page.metadata.pages == 0">
      No hay registros
    </div>

  </div>

  <!-- Modal -->
  <div class="modal fade" id="absenceConfirmation" tabindex="-1" role="dialog"
       aria-labelledby="removeConfirmationLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Confirmar</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>Desea eliminar el registro?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-link" data-bs-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-danger" data-bs-dismiss="modal" (click)="removeEvent(model)">Borrar</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Vacations report modal -->
  <div class="modal fade" id="vacationsReportDialog" tabindex="-1" role="dialog" aria-labelledby="vacationsReportLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="vacationsReportLabel">Boleta de vacaciones</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label for="reportEmployee" class="form-label">Empleado</label>
            <select class="form-select" id="reportEmployee" name="reportEmployee" [(ngModel)]="reportEmployeeId">
              <option [ngValue]="null" disabled>Seleccione...</option>
              <option *ngFor="let employee of employees" [ngValue]="employee.id" [class.text-danger]="employee.archived">{{ employee.name }} {{ employee.lastName }} {{employee.archived? ' (Archivado)' : ''}}</option>
            </select>
          </div>
          <div class="mb-3 d-flex">
            <mt-date-picker [(date)]="reportFrom" label="Desde" class="input-group me-2"></mt-date-picker>
            <mt-date-picker [(date)]="reportTo" label="Hasta" class="input-group"></mt-date-picker>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-link" data-bs-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-primary" [disabled]="!reportEmployeeId" (click)="generatePaidVacationsReport();" data-bs-dismiss="modal">Generar</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="loadFile" tabindex="-1" role="dialog"
       aria-labelledby="loadFileLabel">
    <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Cargar Archivo</h5>
        </div>
        <div class="modal-body">
          <p *ngIf="loading">Cargando archivo...</p>
          <p *ngIf="fileUploadErrors.length == 0 && !loading">Seleccione los comprobantes de ausencia que desea utilizar para justificar la misma.</p>

          <input type="file" #fileUpload id="fileUpload" name="fileUpload" (change)="onFileSelected($event)" multiple="multiple" style="display:none;" />
          <ul *ngIf="fileUploadErrors.length > 0 && !loading" class="list-group list-group-flush">
            <li class="list-group-item d-flex justify-content-between align-items-center">
              Errores encontrados
              <span class="badge bg-danger bg-pill">{{fileUploadErrors.length}}</span>
            </li>
            <li *ngFor="let error of fileUploadErrors" class="list-group-item">
              <span>Línea {{error.line}}</span> <br> <small>{{error.message}}</small>
            </li>
          </ul>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" (click)="fileUpload.click()" title="Seleccionar..." [disabled]="loading">
            Seleccionar...
          </button>
          <button type="button" class="btn btn-link" data-bs-dismiss="modal" (click)="cleanData()" [disabled]="loading">Cerrar</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="removeAttachmentConfirmation" tabindex="-1" role="dialog"
       aria-labelledby="removeConfirmationLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Confirmar</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>Desea eliminar el comprobante {{selectedAttachment?.name}}?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-link" data-bs-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-danger" data-bs-dismiss="modal" (click)="removeAttachment(selectedAttachment?.id)">Borrar</button>
        </div>
      </div>
    </div>
  </div>

</div>


